import useEffectSkipFirst from "../../../hooks/useEffectSkipFirst";
import { useEffect, useMemo } from "react";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import {
  addIndividualAltitudeSelector, individualAltByTimeControllerState, individualAltitudeLabelWithID,
  individualAltitudeWithID,
  removeIndividualAltitudeSelector
} from "../../../store/MapAltitudeState";
import { weatherVisibleWithID } from "../../../store/WeatherContentsState";

function WxIndividualAltDispatcher({contentsID, contents}) {
  const addIndividualAltitude = useSetRecoilState(addIndividualAltitudeSelector);
  const removeIndividualAltitude = useSetRecoilState(removeIndividualAltitudeSelector);
  const setIndividualAltitudeLabelWithID = useSetRecoilState(individualAltitudeLabelWithID(contentsID));

  const visible = useRecoilValue(weatherVisibleWithID(contentsID));

  const [individualAltitude, setIndividualAltitude] = useRecoilState(individualAltitudeWithID(contentsID));

  const individualAltByTimeController = useRecoilValue(individualAltByTimeControllerState)
  const individualAltByTimeControllerDependency = useMemo(() => ([individualAltByTimeController]), [individualAltByTimeController]);

  useEffect(() => {
    const contentsAltitude = contents.getIndividualAltitude();
    if (visible) {
      addIndividualAltitude(contentsAltitude);
    } else {
      removeIndividualAltitude(contentsAltitude);
    }
  }, [visible, contents, addIndividualAltitude, removeIndividualAltitude]);

  useEffect(() => {
    contents.applyIndividualAltitude && contents.applyIndividualAltitude(individualAltitude);
    if (contents.getAltitudeLabel) {
      const altitudeLabel = contents.getAltitudeLabel();
      setIndividualAltitudeLabelWithID(altitudeLabel);
    }
  }, [contents, setIndividualAltitudeLabelWithID, individualAltitude]);

  useEffectSkipFirst(() => {
    contents.applyIndividualAltitude && contents.applyIndividualAltitude(individualAltByTimeController);
    setIndividualAltitude(individualAltByTimeController);
  }, individualAltByTimeControllerDependency);

  //dont draw anything
  return null;
}

export default WxIndividualAltDispatcher;